import PublicLayout from '@/components/layout/PublicLayout'

export default function Privacy() {
  return (
    <PublicLayout>
      <div className="flex-1 flex flex-col items-center p-4 py-8 md:py-12">
        <div className="w-full max-w-3xl">
          {/* Header */}
          <div className="text-center mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-[var(--text-primary)]">Privacy Policy</h1>
            <p className="text-[var(--text-secondary)] mt-2">Last updated: February 2026</p>
          </div>

          <div className="space-y-6 text-[var(--text-secondary)] leading-relaxed">
            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">1. What We Collect</h2>
              <p>
                SSDL collects only the data you explicitly enter: your drink log entries (drink name, volume, alcohol percentage, and timestamp), your weight and gender (used for BAC calculation), and your saved drink templates. All data is stored under a randomly generated passcode — not linked to any personal identity.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">2. What We Do NOT Collect</h2>
              <p>We do not collect:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Names, email addresses, or phone numbers (unless you voluntarily provide an email for key recovery)</li>
                <li>IP addresses or geolocation data</li>
                <li>Device information, browser fingerprints, or hardware identifiers</li>
                <li>Usage analytics or behavioural data</li>
                <li>Cookies or persistent tracking identifiers</li>
              </ul>
              <p className="mt-2">
                We have no analytics platform, no tracking pixels, and no third-party scripts. We genuinely do not know who our users are.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">3. How Data Is Stored</h2>
              <p>
                Your data is stored in Cloudflare's key-value storage infrastructure, identified solely by your random passcode. The last three versions of your data are automatically backed up to protect against accidental loss. All communication between your browser and our servers uses HTTPS encryption.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">4. Data Sharing</h2>
              <p>
                We do not share your data with any third parties. Period. Your data is not sold, licensed, analysed, aggregated, or disclosed to anyone for any reason. The only entity that can access your data is you, using your passcode.
              </p>
              <p className="mt-2">
                No AI or language model ever sees your personal data. The only AI feature is drink lookup, which sends the drink name you search for (e.g. "Corona 330ml") to retrieve its nutritional information. Your drink log, BAC history, and all other personal data is never sent to any AI service.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">5. Optional Email</h2>
              <p>
                If you choose to register a backup email address for key recovery, that email is stored alongside your data and is used exclusively to send you a passcode recovery email if you request one. It is not used for marketing, newsletters, or any other purpose, and is not shared with any third party.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">6. Data Deletion</h2>
              <p>
                You can delete your drink log data at any time by clearing your entries within the app. Since there are no accounts in the traditional sense, there is no formal "account deletion" process — if you stop using a passcode and clear its data, it effectively ceases to exist.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">7. Client-Side Processing</h2>
              <p>
                BAC calculations, session analysis, trend charts, risk assessments, and PDF report generation all happen locally in your browser. Your data is sent to the server only for storage and retrieval — it is never processed, analysed, or aggregated server-side.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">8. Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. Continued use of the service after changes are posted constitutes acceptance of the updated policy. We encourage you to review this page periodically.
              </p>
            </section>
          </div>
        </div>
      </div>
    </PublicLayout>
  )
}
